import React from "react";
import './styles.scss';
import DATA from 'utils/data.json';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';

import 'swiper/css';
import "swiper/css/thumbs";
import useMediaQuery from "hooks/useMediaQuery";

const TESTIMONIAL_DATA = DATA.testimonial;
const IMAGES = [1,2,3,4,5]

const Testimonial = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');
    return (
        <section id='testimonial-id' className="testimonial-block">
            <p className="title container">{TESTIMONIAL_DATA.title}</p>
            <div className="container">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    loop={true}
                    loopedSlides={4}
                    centeredSlides
                    className='slide'
                    modules={[Pagination]}
                    pagination={{
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"><img class="pagination-bullet"/></span>';
                        }
                    }}
                >
                    {TESTIMONIAL_DATA.list.map((item, index) => {
                        return (
                            <SwiperSlide className='item' key={index}>
                                <img alt="" src={item.image} className='item__image' />
                                <p className='item__name'>{item.name}</p>
                                <p className='item__index'>{item.index}</p>
                                <p className='item__position'>{item.position}</p>
                                <p className='item__desc'>{item.desc}</p>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
            <Swiper
                slidesPerView={isMobile ? 1.2 : 2}
                loop={true}
                spaceBetween={16}
                centeredSlides
                autoplay
                modules={[Autoplay]}
                className='img-slide'
            >
                {IMAGES.map((item, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <img src={`/images/testimonial/Edu${item}.jpg`} alt='' className='image' />
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </section>
    )
}

export default Testimonial